import ProjectConfig from 'ProjectConfig';

export const toggleCaptchaBadge = show => {
  const isReCaptchaEnabled = ProjectConfig.reCaptchaEnabled;
  
  if (isReCaptchaEnabled) {
    const badge = document.getElementsByClassName('grecaptcha-badge')[0];
    if (badge && badge instanceof HTMLElement) {
      badge.style.visibility = show ? 'visible' : 'hidden';
    }
  }
};
